if (!customElements.get('product-media-gallery-responsive')) {
  class ProductMediaGalleryResponsive extends HTMLElement {
    constructor() {
      super();
      this.gallerySwiper = this.querySelector('.product-media-gallery');
      this.thumbsSwiper = this.querySelector('.product-media-thumbs');
      this.isMobile = window.innerWidth < 750;
    }

    connectedCallback() {
      this.initResizeListener();
      this.updateSwiperSlides();
    }

    initResizeListener() {
      window.addEventListener('resize', () => {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth < 750;

        if (wasMobile !== this.isMobile) {
          this.updateSwiperSlides();
        }
      });
    }

    updateSwiperSlides() {
      if (this.gallerySwiper && this.gallerySwiper.swiper) {
        this.updateSwiperInstance(this.gallerySwiper.swiper, 'gallery');
      }

      if (this.thumbsSwiper && this.thumbsSwiper.swiper) {
        this.updateSwiperInstance(this.thumbsSwiper.swiper, 'thumbs');
      }
    }

    updateSwiperInstance(swiper, type) {
      const classSuffix = type === 'thumbs' ? 'thumbnail' : type;
      const mobileSlides = this.querySelectorAll(`.td-frb__${classSuffix}-swiper-slide--mobile-only`);

      mobileSlides.forEach((slide) => {
        slide.style.display = this.isMobile ? '' : 'none';
      });

      swiper.update();
    }
  }

  customElements.define('product-media-gallery-responsive', ProductMediaGalleryResponsive);
}
